import React, {Fragment} from 'react';
import TextInput from '../../form/TextInput';
import ProductEditor from '../../editors/productEditor';
import Select from '../../form/Select';
import createForm from "./Form";
import classNames from 'classnames';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {
    BarcodeFormatter, ComponentFormatter,
    CurrencyFormatter, ProductColumn,
    ProductSelect,
    productTooltip,
    UnitFormatter
} from "../../../utils/formatters";
import {ifCompletedInput} from "../../../utils/other";
import {postData} from "../../../utils/request";
import Icon from "../../form/Icon";
import Modal from "../../layout/Modal";
import SelectorDocuments from "../../form/SelectorGrid/SelectorDocuments";
import UIfx from 'uifx';
import beepErrorMp3 from './../../../sounds/beep-error.mp3';
import beepSuccessMp3 from './../../../sounds/beep-success.mp3';
import ComponentConfig from "../../form/ComponentConfig";
import Button from "../../form/Button";
import CheckBox from "../../form/CheckBox";
import {Tooltip} from "react-tippy";
import ModalEditor from "../ModalEditor";
import {productShortForm} from "./productForm";
import StoreOrderEditor from "../storeorder/storeorderEditor";
import FragmentEditor from "../FragmentEditor";
import DetailsButton from "../../form/DetailsButton";

const beepError = new UIfx(beepErrorMp3, {});
const beepSuccess = new UIfx(beepSuccessMp3, {});

class storeorderForm extends React.Component {

    state = {
        picked: null,
        updateItem: null,
        filtered: false,
        newProduct: null
    }

    updateItem = async (item) => {
        let actionparams = {
            parentcomponent: this.props.componentConfig.componentname,
            listfield: "items",
            parentid: this.props.values[this.props.componentConfig.idfield]
        };

        const action = item.id ? ((item.qty === undefined || item.qty === null) && parseInt(item.pickedqty || 0) === 0 ? "removeItemsFromList" : "updateItems") : "addItemsToList";

        let items = [item].map((item) => {
            item.OperationList_id = this.props.values[this.props.componentConfig.idfield];
            return item;
        });

        if (action === "addItemsToList") {
            items = items.map((item) => ({data: {...item, qty: item.qty || 0, pickedqty: parseInt(item.pickedqty || 0) + parseInt(item.picked || 0)}}));
        } else if (action === "updateItems") {
            items = items.map((item) => ({data: {...item, qty: item.qty || 0, pickedqty: parseInt(item.pickedqty || 0) + parseInt(item.picked || 0)}}));
        }

        actionparams = {
            ...actionparams,
            action: "componentlist." + action,
            items: items
        };
        try {
            await postData(actionparams);
        } catch (e) {
            console.error(e);
        }
    }

    addPickedItem = async () => {
        const item = {...this.state.picked};
        if (item.picked > 1000) {
            beepError.play();
            return;
        }
        await this.updateItem(item);
        this.setState({
            picked: null,
            updateItem: null
        }, () => {
            this.items.refreshBackground();
            this.newProductOnListIn.hide();
            // szomorú timeout
            setTimeout(() => {
                this.productPicker.focus();
            }, 50);
            beepSuccess.play();
        });
    }

    render() {
        const sortable = true;
        const filterable = true;
        const componentButton = this.props.clientFields;
        const addItem = this.props.stateTypes.CONFIRMED_STATE(this.props.values.state) && this.props.values.ordertype !== undefined && this.props.values.serviceprovider_type === "internal_store";
        const claimCheckState = this.props.stateTypes.CLAIM_CHECK_STATE(this.props.values.state);
        const isExternal = this.props.values.serviceprovider_type === "external_store";
        return (
            <Fragment>
                {this.props.closeOrder && <Modal
                    type="default"
                    state="on"
                    header="Eltérés"
                    disabled={this.props.isLoading}
                    buttons={[
                        {
                            text: 'Igen',
                            tabIndex: 1,
                            props: {color: 'danger', focus: true, disabled: this.props.isLoading},
                            onClick: async () => {
                                await this.props.closeOrderAction();
                            }
                        },
                        {
                            text: 'Mégse',
                            tabIndex: 2,
                            props: {color: 'default', disabled: this.props.isLoading},
                            onClose: true,
                            onClick: async () => {
                                await this.props.cancelCloseOrderAction();
                            }
                        }
                    ]}
                >
                    Eltérés van a kért és a teljesített darabszámok között. Biztos befejezed így?
                </Modal>}
                <Modal
                    ref={(el) => this.newProductOnListIn = el}
                    type="default"
                    header="Eltérés"
                    buttons={[
                        {
                            text: 'Rögzítés',
                            tabIndex: 1,
                            props: {color: 'primary', focus: true},
                            onClick: async () => {
                                await this.addPickedItem();
                            }
                        },
                        {
                            text: 'Mégse',
                            tabIndex: 2,
                            props: {color: 'default'},
                            onClose: true,
                            onClick: () => {
                                this.newProductOnListIn.hide();
                                this.numberInput.focus();
                                this.numberInput.select();
                            }
                        }
                    ]}
                >
                    Listán nem szereplő terméket szeretnél felvenni!
                </Modal>
                <Modal
                    ref={(el) => this.newProductOnListOut = el}
                    type="default"
                    header="Eltérés"
                    buttons={[
                        {
                            text: 'Ok',
                            tabIndex: 2,
                            props: {color: 'primary', focus: true},
                            onClose: true,
                            onClick: () => {
                                this.newProductOnListOut.hide();
                                this.productPicker.focus();
                            }
                        }
                    ]}
                >
                    Ez a tétel nem szerepel a listán!
                </Modal>
                <form onSubmit={this.props.handleSubmit}>
                    <div className="row form-row">
                        <div className={classNames({"col-md-2": componentButton, "col-md-6": !componentButton})}>
                            <TextInput name={this.props.componentConfig.idfield} value={this.props.values[this.props.componentConfig.idfield]} label="Kód"
                                       role="idfield" {...this.props.getFieldProps(this.props.componentConfig.idfield)}/>
                        </div>
                        <div className={classNames({"col-md-4": componentButton, "col-md-6": !componentButton})}>
                            <TextInput
                                name={!isExternal ? "fullnotenum" : "notenum"}
                                disabled={!isExternal}
                                value={!isExternal ? this.props.values.fullnotenum : this.props.values.notenum}
                                label="Szállítólevél szám"
                                {...this.props.getFieldProps(!isExternal ? "fullnotenum" : "notenum")}
                                saveChanges={this.props.setFieldValue}
                            />
                        </div>
                        {componentButton && <Fragment>
                            <div className="col-md-2">
                                <TextInput
                                    name="client_component"
                                    value={this.props.values.client_component}
                                    label="Tevékenység"
                                    saveChanges={this.props.setFieldValue}
                                    formatter={(value) => ComponentFormatter({component: value})}
                                    {...this.props.getFieldProps("client_component")}
                                    disabled={true}
                                />
                            </div>
                            <div className="col-md-2">
                                <TextInput
                                    name="client_component_id"
                                    value={this.props.values.client_component_id}
                                    label="Id"
                                    saveChanges={this.props.setFieldValue}
                                    {...this.props.getFieldProps("client_component_id")}
                                    disabled={true}
                                />
                            </div>
                            <div className="col-md-2">
                                <DetailsButton
                                    component_type={this.props.values.client_component}
                                    component_id={this.props.values.client_component_id}
                                />
                            </div>
                        </Fragment>}
                    </div>
                    <div className="row form-row">
                        <div className="col-md-6">
                            <Select
                                label="Partner"
                                name="client.partner"
                                component="partner"
                                objectValue={true}
                                labelKey="name"
                                storeType="remote"
                                value={(this.props.values.client || {}).partner}
                                {...this.props.getFieldProps("client.partner")}
                                disabled={true}
                                saveChanges={this.setFieldValue}
                            />
                        </div>
                        <div className="col-md-6">
                            <TextInput
                                name="client.destination.name"
                                value={((this.props.values.client || {}).destination || {}).name}
                                label="Hova"
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("client.destination.name")}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="row form-row">
                        <div className="col-md-12">
                            {this.props.values[this.props.componentConfig.idfield] && <Fragment>
                                {addItem && <div className="row form-row">
                                    <div className="col-md-9">
                                        <Select
                                            {...this.props.getFieldProps("productPicker")}
                                            ref={(input) => this.productPicker = input}
                                            label={"Termék"}
                                            component={"StoreOrderItemPool"}
                                            labelKey={"displayname"}
                                            storeType={"remote"}
                                            valueKey={"product_id"}
                                            view={["product_id","qty","pickedqty"]}
                                            optionsTemplate={ProductSelect}
                                            parameters={{"storeorder_id": this.props.values[this.props.componentConfig.idfield]}}
                                            autoSelect={true}
                                            searchFormatter={BarcodeFormatter}
                                            placeholder={"Vonalkód vagy cím"}
                                            objectValue={true}
                                            openIfHasOptions={true}
                                            value={this.state.picked}
                                            saveChanges={(field, value) => {
                                                value.picked = 1;
                                                this.setState({picked: value}, () => {
                                                    this.numberInput.focus();
                                                    this.numberInput.select();
                                                });
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <TextInput
                                            disabled={!this.state.picked}
                                            type="number"
                                            ref={(input) => this.numberInput = input}
                                            name="picked"
                                            value={(this.state.picked || {}).picked}
                                            label="Darabszám (Összesen)"
                                            onKeyDown={(e, field, value) => {
                                                if (ifCompletedInput(e)) {
                                                    if (this.props.orderTypes.SALES_ORDER(this.props.values.ordertype) && (this.state.picked.qty === undefined || this.state.picked.qty === null)) {
                                                        this.newProductOnListOut.show();
                                                    } else {
                                                        this.setState({
                                                            picked: {
                                                                ...this.state.picked,
                                                                picked: value
                                                            }
                                                        }, async () => {
                                                            if (this.state.picked.qty === undefined || this.state.picked.qty === null) {
                                                                this.newProductOnListIn.show();
                                                            } else {
                                                                await this.addPickedItem();
                                                            }
                                                        });
                                                    }
                                                } else if(e.which === 27) {
                                                    this.setState({
                                                        picked: null,
                                                        updateItem: null
                                                    }, () => {
                                                        this.productPicker.focus();
                                                    });
                                                }
                                            }}
                                            {...this.props.getFieldProps("picked")}
                                            saveChanges={(field, value) => {
                                                if (this.state.picked) {
                                                    this.setState({
                                                        picked: {
                                                            ...this.state.picked,
                                                            picked: value
                                                        }
                                                    });
                                                }
                                            }}
                                        />
                                    </div>
                                    {this.state.picked && <div className="col-md-12">
                                        <ProductSelect {...this.state.picked}/>
                                    </div>}
                                </div>}
                                <SelectorGrid
                                    {...this.props.getFieldProps("items")}
                                    ref={(e) => this.items = e}
                                    className={"p-small-table"}
                                    exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel"}]}
                                    view={["id", "name", "qty", "product_id"]}
                                    filter={this.state.filtered ? [{field: "diffqty", value: 0, operator: "!="}] : []}
                                    paginatorRight={() => <Tooltip title={!this.state.filtered ? "Csak az eltérések mutatása" : "Mindent mutat"}><CheckBox
                                        onIcon={{lib: "fa", name: "box"}}
                                        offIcon={{lib: "fa", name: "box-open"}}
                                        value={this.state.filtered}
                                        label={false}
                                        saveChanges={(field, value) => {
                                            this.setState({filtered: !!value});
                                        }}
                                    /></Tooltip>}
                                    onItemUpdate={async (item, oldItem, field, rowIndex, {listfieldComponentConfig}) => {
                                        const updateItem = {};
                                        Object.keys(listfieldComponentConfig.fielddefs).map((key) => {
                                            updateItem[key] = item[key];
                                        });
                                        let actionparams = {
                                            parentcomponent: this.props.componentConfig.componentname,
                                            listfield: "items",
                                            parentid: this.props.values[this.props.componentConfig.idfield],
                                            action: "componentlist.updateItems",
                                            items: [updateItem]
                                        };
                                        await postData(actionparams);
                                        return true;
                                    }}
                                    columns={{
                                        "displayname": {
                                            ...ProductColumn("product_id"),
                                            width: 2,
                                        },
                                        "barcode": {
                                            header: 'Vonalkód',
                                            width: 1,
                                            sortable,
                                            filterable
                                        },
                                        "listprice": {
                                            header: 'Ár',
                                            width: 2,
                                            sortable,
                                            filterable,
                                            renderer: CurrencyFormatter,
                                            className: "currency"
                                        },
                                        "qty": {
                                            header: 'Darabszám',
                                            width: 2,
                                            sortable,
                                            filterable,
                                            renderer: (value, row) => UnitFormatter(value || 0, row.unit),
                                            className: "unit"
                                        },
                                        "pickedqty": {
                                            header: this.props.orderTypes.SALES_ORDER(this.props.values.ordertype) ? "Kiszedve" : "Bevételezve",
                                            width: 2,
                                            sortable,
                                            filterable,
                                            aggregation: (value, row) => UnitFormatter(value || 0, row.unit),
                                            renderer: (value, row) => {
                                                return <Fragment>{!this.props.getFieldProps("pickedqty").disabled && this.props.stateTypes.CONFIRMED_STATE(this.props.values.state) && <a className="btn btn-danger btn-xs pull-right" style={{marginLeft: "5px", marginTop: "-3px"}} onClick={async (e) => {
                                                    e && e.preventDefault();
                                                    const item = {...row};
                                                    item.pickedqty = 0;
                                                    await this.updateItem(item);
                                                    if (this.state.picked && this.state.picked.product_id === item.product_id) {
                                                        this.setState({picked: {...this.state.picked, pickedqty: 0}});
                                                    }
                                                    this.items.refreshBackground();
                                                }}><Icon lib="fa" name="times-circle" /></a>}<span className="pull-right">{UnitFormatter(value || 0, row.unit)}</span></Fragment>;
                                            },
                                            className: "unit"
                                        },
                                        ...(claimCheckState ? {
                                            "noteqty": {
                                                header: "Bizonylat mennyiség",
                                                width: 2,
                                                sortable,
                                                filterable,
                                                aggregation: (value, row) => UnitFormatter(value, row.unit),
                                                renderer: (value, row) => UnitFormatter(value, row.unit),
                                                className: "unit",
                                                editor:
                                                    (parent) =>
                                                        (props, value) =>
                                                            <TextInput type="number" name="noteqty" label={false} focus value={value}
                                                                       onKeyDown={(e, field, value) => {ifCompletedInput(e) && parent.onEditorValueChange(props, value);}}
                                                                       onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/>
                                            },
                                        } : {})
                                    }}
                                    rowClassName={(rowData) => {
                                        const pickedqty = parseInt(rowData.pickedqty || 0);
                                        const qty = parseInt(rowData.qty || 0);
                                        const classes = {};
                                        if (pickedqty > qty) {
                                            classes["p-highlight danger"] = true;
                                        } else if(qty > pickedqty) {
                                            classes["p-highlight"] = true;
                                        }
                                        return classes;
                                    }}
                                    aggregations={{
                                        fields: {
                                            "qty": {
                                                field: "qty", type: "SUM"
                                            },
                                            "pickedqty": {
                                                field: "pickedqty", type: "SUM"
                                            },
                                            ...(claimCheckState ? {
                                                "noteqty": {
                                                    field: "noteqty", type: "SUM"
                                                },
                                            } : {})
                                        }
                                    }}
                                    onLoadCompleted={(response) => {
                                        if (response.aggregations && response.aggregations[0]) {
                                            this.props.setDiff(parseInt(response.aggregations[0].qty || "0") - parseInt(response.aggregations[0].pickedqty || "0"))
                                        } else {

                                        }
                                    }}
                                    listfield="items"
                                    data={this.props.values}
                                    orderBy={{field: "displayname", direction: "ASC"}}
                                    componentConfig={this.props.componentConfig}
                                />
                            </Fragment>}
                        </div>
                    </div>
                    {this.props.values[this.props.componentConfig.idfield] && (this.props.stateTypes.CLAIM_STATE(this.props.values.state) || this.props.stateTypes.CLAIM_CHECK_STATE(this.props.values.state)) && <div className="row form-row">
                        <div className="col-md-12">
                            <label className="control-label">Ismeretlen termékek</label>
                            {this.state.newProduct && <ProductEditor
                                editorContext="UnknownProduct"
                                newProduct={{name: this.state.newProduct.name, listprice: this.state.newProduct.price, barcode: this.state.newProduct.barcode}}
                                onCancelNewProduct={() => this.setState({newProduct: null})}
                                formType={productShortForm}
                                saveForm={() => {
                                    this.setState({newProduct: null});
                                    this.items && this.items.refresh();
                                    this.unknowns && this.unknowns.refresh();
                                }}
                                editor={(props) => <ModalEditor {...props} onClose={() => this.setState({newProduct: null})} state="on"/>}
                                list={() => null}
                                ref={(newProductEditor) => this.newProductEditor = newProductEditor}
                            />}
                            <SelectorGrid
                                {...this.props.getFieldProps("unknowns")}
                                disabled={false}
                                ref={(e) => this.unknowns = e}
                                className={"p-small-table"}
                                exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel"}]}
                                component="StoreOrderUnknownProduct"
                                selectionMode="single"
                                filter={[
                                    {
                                        field: "component_type",
                                        value: this.props.componentConfig.componentname
                                    },{
                                        field: "component_id",
                                        value: this.props.values[this.props.componentConfig.idfield]
                                    }
                                ]}
                                selection={this.state.newProduct}
                                onSelectionChange={(selection) => {
                                    //this.setState({newProduct: selection.value});
                                }}
                                columns={{
                                    "name": {
                                        header: 'Megnevezés',
                                        width: 2,
                                        sortable,
                                        filterable
                                    },
                                    "barcode": {
                                        header: 'Vonalkód',
                                        width: 2,
                                        sortable,
                                        filterable
                                    },
                                    "price": {
                                        header: 'Ár',
                                        width: 2,
                                        sortable,
                                        filterable,
                                        className: "currency",
                                        renderer: CurrencyFormatter
                                    },
                                    "qty": {
                                        header: 'Darabszám',
                                        width: 2,
                                        sortable,
                                        filterable,
                                        renderer: (value, row) => UnitFormatter(value || 0, row.unit),
                                        className: "unit"
                                    }
                                }}
                                aggregations={{
                                    fields: {
                                        "qty": {
                                            field: "qty", type: "SUM"
                                        }
                                    }
                                }}
                                orderBy={{field: "name", direction: "ASC"}}
                            />
                        </div>
                    </div>}
                    <div className="row form-row">
                        <div className="col-md-12">
                            {
                                this.props.componentConfig.fielddefs.documents
                                && this.props.componentConfig.fielddefs.documents.type === "componentlist"
                                && <Fragment>
                                    <label className="control-label">Dokumentumok</label>
                                    <SelectorGrid
                                        {...this.props.getFieldProps("documents")}
                                        disabled={false}
                                        componentConfig={this.props.componentConfig}
                                        className={"p-small-table"}
                                        view={["filename", "path"]}
                                        type={SelectorDocuments}
                                        pageSize={0}
                                        listfield={"documents"}
                                        data={this.props.values}
                                        orderBy={{field: "filename", direction: "ASC"}}
                                    />
                                   </Fragment>
                            }
                        </div>
                    </div>
                    {this.props.values[this.props.componentConfig.idfield] && this.props.stateTypes.CLAIM_STATE(this.props.values.state) && <div className="row form-row">
                        <div className="col-md-12">
                            <label className="control-label">Raktári rendelések</label>
                            <StoreOrderEditor
                                editorContext="StoreOrderStoreOrderEditor"
                                client={this.props}
                                listFilter={[
                                    {
                                        field: "client_component",
                                        value: this.props.componentConfig.componentname
                                    },{
                                        field: "client_component_id",
                                        value: this.props.values[this.props.componentConfig.idfield]
                                    }
                                ]}
                                list={FragmentEditor}
                                editor={ModalEditor}
                                other={() => null}
                                selection={null}
                                onProcessAction={() => {
                                    if (!this.props.isLoading) {
                                        this.props.reloadForm && this.props.reloadForm();
                                    }
                                }}
                            />
                        </div>
                    </div>}
                </form>
                {this.props.diffModal}
            </Fragment>
        );
    }
}

export default createForm(storeorderForm);
